<template>
  <q-layout view="lhh LpR lff">
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/statistics">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Báo cáo thực hiện kế hoạch</div>
          </div>
          <div class="col-xs-12 col-md-10 row">
            <div class="col-xs-12 col-sm-4 col-lg-3 q-pa-md">
              <q-select emit-value v-model="term" :options="terms" option-value="id" option-label="name" :display-value="$getNameById(terms, term ,'name')" label="Kỳ">
                <template v-slot:prepend>
                  <q-icon name="filter_vintage" />
                </template>
              </q-select>
            </div>
            <div class="col-xs-12 col-sm-3 col-lg-3 q-pa-md">
              <div class="row">
                <q-input class="col self-center" v-model="month" label="Tháng" readonly></q-input>
                <!-- <q-btn icon="close" size="20px" style="height: 25%" flat class="col-1 cursor-pointer " v-if="month" @click="month = null; oldMonth = null"/> -->
                <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 cursor-pointer">
                  <q-popup-proxy>
                    <q-date ref="qMonth" v-model="modelMonth" minimal default-view="Months" v-close-popup='monthPopUp' @click="checkMonth()"/>
                  </q-popup-proxy>
                </q-btn>
              </div>
            </div>
            <div class="col-xs-12 col-sm-5 q-pa-md">
              <div class="row">
                <q-input clearable class="col-7 self-center" v-model="year" label="Năm" readonly></q-input>
                <!-- <q-btn icon="close" size="20px" style="height: 25%" flat class="col-1 cursor-pointer" v-if="year" @click="year = null; oldYear = null"/> -->
                <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 cursor-pointer">
                  <q-popup-proxy>
                    <q-date ref='qYear' v-model="modelYear" minimal default-view="Years" v-close-popup='yearPopUp' @click="checkYear()"/>
                  </q-popup-proxy>
                </q-btn>
              <q-btn style="height: 25%" icon="cloud_download" flat color="black" size="20px" @click="download" class="col-2 cursor-pointer" :disable="disableBtn" :loading="isFetching"/>
              </div>
            </div>
          </div>
        </q-card>

        <div v-for="(item, key) in tables" :key="key">
          <q-table
            :title="item.title"
            :data="item.data"
            :style="`display: ${item.show ? 'block' : 'none'}` "
            :columns="headers"
            row-key="name"
            no-data-label="Không có dữ liệu"
            :pagination.sync="pagination"
            :loading="isFetching"
            class="q-mb-md"
            :hide-bottom="!_.isEmpty(item.data)"
            >
            <template v-slot:top-row ="props">
              <q-tr class="text-bold text-red uppercase" v-if="!_.isEmpty(item.data)">
                <q-th>Tỉ lệ thực hiện trung bình</q-th>
                <q-th class="text-center" v-for="(row,index) in _.cloneDeep(headers).slice(1)" :key="index">
                  <span v-if="row.name === 'percent' ">
                    {{item.averagePercent > 0 ? item.averagePercent.toFixed(2)+'%' : item.averagePercent}}
                  </span>
                </q-th>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
// eslint-disable-next-line
import _ from 'lodash'
const XlsxPopulate = require('xlsx-populate')
export default {
  name: 'DailyStatistics',
  data() {
    return {
      tables: {
        sum: {
          title: 'Tổng',
          data: [],
          farmName: 'sum',
          show:false
        },
      },
      headers: [
        {
          name: 'no',
          required: true,
          label: 'No',
          align: 'left',
          format: (val, row) => `${row.__index + 1}`,
          sortable: true
        },
        {
          name: 'job',
          required: true,
          label: 'Công việc',
          align: 'center',
          field: row => row.job,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'type',
          required: true,
          label: 'Loại công',
          align: 'center',
          field: row => row.type,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'plan',
          required: true,
          label: 'Kế hoạch',
          align: 'center',
          field: row => row.plan,
          format: val => `${val ? val.toFixed(2) : val}`,
          sortable: true
        },
        {
          name: 'work',
          required: true,
          label: 'Thực hiện',
          align: 'center',
          field: row => row.work,
          format: val => `${val ? val.toFixed(2) : val}`,
          sortable: true
        },
        {
          name: 'left',
          required: true,
          label: 'Còn lại',
          align: 'center',
          field: row => (row.plan - row.work),
          format: val => `${val ? val.toFixed(2) : 0}`,
          sortable: true
        },
        {
          name: 'percent',
          required: true,
          label: 'Tỉ lệ thực hiện',
          align: 'center',
          field: row => (row.plan>0 && row.work>0) ? (row.work/row.plan*100) : 0,
          format: val => `${val ? val.toFixed(2) + '%' : 0}`,
          sortable: true
        },
        {
          name: 'unit',
          required: true,
          label: 'Đơn vị',
          align: 'center',
          field: row => row.unit,
          format: val => `${val}`,
          sortable: true
        },
      ],
      pagination: {
        rowsPerPage: 0,
        // sortBy: 'job'
      },
      isFetching: false,
      dataFetched: [],
      yearPopUp: false,
      monthPopUp: false,
      load: false,
      plans: null,
      tableKey: 0,
      selectedRowIndex: null,
      defaultDateFormat: 'DD',
      disableBtn: false,
      modelMonth: '2019/06/06',
      modelYear: '2019/06/06',
      month: moment.utc().format('M'),
      year:  moment.utc().format('YYYY'),
      oldYear: null,
      oldMonth: null,
      term: moment.utc().format('DD') <= 15 ? 'a' : 'b',
      terms: [{
        name:'Kỳ A',
        id: 'a'
      },
      {
        name: 'Kỳ B',
        id: 'b'
      }],
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    tag() {
      return this.year + ((this.month < 10 ? '0' : '') + this.month) + this.term.toUpperCase()
    },
    ...mapGetters([
      'farmStore',
      'jobStore',
      'permission'
    ])
  },
  methods: {
    async fetchData() {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let vm = this
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      if (roles.length > 0) {
        vm.checkPermission(roles)
        vm.isFetching = true
        await vm.$command.execute('getPlanStatistics',{tag: vm.tag}).then((res) => {
          vm.dataFetched = res.data
          vm.processData(vm.dataFetched)
        }).catch(error => {
          vm.$q.notify({
            message: error.toString(),
            color: 'red',
            icon: 'error'
          })
        })
        vm.isFetching = false
      } else {
        vm.disableBtn = true
        vm.$q.notify({
          message: 'You don\'t have permission',
          color: 'red',
          icon: 'error'
        })
      }
    },
    checkPermission(roles) {
      let vm = this
      if (roles.length > 0) {
       for (let i in vm.farmStore.list)
        {
          vm.tables['id'+i] = {
            title: vm.farmStore.list[i].name,
            farmName: vm.farmStore.list[i].name,
            farm: vm.farmStore.list[i].id,
            data: [],
            show:false,
          }
        }

        if (roles.indexOf('BOM') > -1) {
          for (let i in vm.tables) {
            vm.tables[i].show = true
          }
        }
        else {
          roles.forEach(r => {
            let numberPattern = /\d+/g
            let farm = r.match(numberPattern)
            vm.tables[`id${farm-1}`].show = true
          })
        }
      }
    },
    processData(resData) {
      let vm = this
      for(let i in vm.tables)
      {
        vm.tables[i].data = !vm.tables[i].show && !resData && !resData.data ? [] : vm._.cloneDeep(resData.data.filter(item => item.farm === vm.tables[i].farmName))
        vm.tables[i].averagePercent = !vm.tables[i].show && !resData && !resData.averagePercent && !resData.averagePercent[vm.tables[i].farmName] ? 0 :vm._.cloneDeep(resData.averagePercent[vm.tables[i].farmName])
      }
    },
    checkMonth() {
      this.modelMonth = '2019/'+ (this.$refs.qMonth.innerModel.month < 10 ? '0' :'') + this.$refs.qMonth.innerModel.month + '/06'
      this.month = this.$refs.qMonth.innerModel.month
      if (this.oldMonth - this.month !== 0) {
        this.oldMonth = this.month
        this.monthPopUp = true
      }
      else {
        this.$refs.qMonth.view = "Months"
        this.monthPopUp = false
      }
    },
    checkYear() {
      this.modelYear = this.$refs.qYear.innerModel.year + '/06/06'
        this.year = this.$refs.qYear.innerModel.year
        if (this.oldYear - this.year !== 0) {
          this.oldYear = this.year
         this.yearPopUp = true
        }
        else {
          this.$refs.qYear.view = "Years"
          this.yearPopUp = false
        }
    },
    download() {
      let vm = this
      let csvFields = [['STT','Công việc', 'Loại công', 'Kế hoạch', 'Thực hiện','Còn lại', 'Tỉ lệ thực hiện', 'Đơn vị']]
      let colWidth = [
        {col: 'A', wpx:10}, //stt
        {col: 'B',wpx:30},//nt
        {col: 'C',wpx:20}, //lo
        {col: 'D',wpx:20}, //o
        {col: 'E',wpx:20},// ma cv
        {col: 'F',wpx:20},//ten cv
        {col: 'G',wpx:20},//loai
        {col: 'H',wpx:20},// sl
      ]
      ///XlsxPopulate
      XlsxPopulate.fromBlankAsync().then(workbook => {
        vm._.forEach(vm.tables, table => {
          let sheetData = vm._.cloneDeep(csvFields)
          if (table.show)
          {
            for (let i in table.data) {
              let row = [i]
              row.push(table.data[i].job)
              row.push(table.data[i].type)
              row.push(table.data[i].plan)
              row.push(table.data[i].work)
              row.push(table.data[i].plan - table.data[i].work)
              row.push(table.data[i].plan > 0 && table.data[i].work > 0 ? (table.data[i].work / table.data[i].plan * 100) : 0)
              row.push(table.data[i].unit)
              sheetData.push(row)
            }
            sheetData.push(['','Tỉ lệ thực hiện trung bình','','','','',table.averagePercent,''])
            
            if (workbook.sheet(0).name() !== "Sheet1") {
              workbook.addSheet(table.title)
            }
            let wsLength = workbook.sheets().length-1
              workbook.sheet(wsLength).name(table.title).row(1).style("bold", true)
              workbook.sheet(wsLength).cell("A1").value(sheetData)
              workbook.sheet(wsLength).name(table.title).row(table.data.length+2).style("bold", true)
              for (let j in colWidth) {
                workbook.sheet(wsLength).column(colWidth[j].col).width(colWidth[j].wpx)
            }
          }
        })
        return workbook.outputAsync()
        }).then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, 'Bao-cao-ke-hoach-'+vm.tag + '.xlsx')
          }
          else {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            document.body.appendChild(a)
            a.href = url
            a.download = 'Bao-cao-ke-hoach-'+vm.tag + '.xlsx'
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }).catch(err => {
          throw err
        })
    }
  },
  watch: {
    tag() {
      this.fetchData()
    }
  },
}
</script>
